/** next/image shim: a plain <img>. The app serves its own sized JPEGs from
 * /images/* (SW CacheFirst) — Next's optimizer was never in that path. */
import { forwardRef, type ImgHTMLAttributes } from "react";

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  fill?: boolean;
  priority?: boolean;
  sizes?: string;
  quality?: number;
};

const Image = forwardRef<HTMLImageElement, Props>(function Image(
  { fill, priority, sizes: _s, quality: _q, style, ...rest },
  ref,
) {
  const fillStyle = fill
    ? ({ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" } as const)
    : undefined;
  // next/image defaults non-priority images to lazy — keep that: eager-by-
  // default fetched EVERY hero image on first page view (~2.5 MB for a
  // 6-image trip), the exact egress trap lesson 26 warns about. Lazy means
  // only in-viewport images fetch; the rest load on scroll and cache then.
  return <img ref={ref} loading={priority ? "eager" : (rest.loading ?? "lazy")} style={{ ...fillStyle, ...style }} {...rest} />;
});
export default Image;
